import { useIsArtefactEditable } from '@modules/common/hooks';
import { useDashboardStore } from '../store/useDashboardStore';

export function useIsDashboardEditable() {
  const editToken = useDashboardStore(({ dashboard }) => dashboard.editToken);
  const status = useDashboardStore(({ dashboard }) => dashboard.status);
  const isReadOnly = useDashboardStore(({ visual }) => visual.isReadOnly);
  const isDefaultContext = useDashboardStore(
    ({ visual }) => visual.context === 'Default',
  );
  const isArtefactEditable = useIsArtefactEditable({
    editToken,
    status,
  });
  const isEditable = isDefaultContext ? isArtefactEditable : true;

  return isEditable && !isReadOnly;
}
